"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 316"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 317"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.36302 5.72671C6.0116 5.72671 5.72671 6.0116 5.72671 6.36302V12.0898C5.72671 12.4412 6.0116 12.7261 6.36302 12.7261H12.0898C12.4412 12.7261 12.7261 12.4412 12.7261 12.0898V6.36302C12.7261 6.0116 12.4412 5.72671 12.0898 5.72671H6.36302ZM4.4541 6.36302C4.4541 5.30875 5.30875 4.4541 6.36302 4.4541H12.0898C13.144 4.4541 13.9987 5.30875 13.9987 6.36302V12.0898C13.9987 13.144 13.144 13.9987 12.0898 13.9987H6.36302C5.30875 13.9987 4.4541 13.144 4.4541 12.0898V6.36302Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.90892 1.27261C1.74016 1.27261 1.57831 1.33965 1.45898 1.45898C1.33965 1.57831 1.27261 1.74016 1.27261 1.90892V7.63566C1.27261 7.80442 1.33965 7.96627 1.45898 8.0856C1.57831 8.20493 1.74016 8.27197 1.90892 8.27197H2.54522C2.89664 8.27197 3.18153 8.55685 3.18153 8.90827C3.18153 9.25969 2.89664 9.54458 2.54522 9.54458H1.90892C1.40264 9.54458 0.917099 9.34346 0.559108 8.98547C0.201117 8.62748 0 8.14194 0 7.63566V1.90892C0 1.40264 0.201117 0.917099 0.559108 0.559108C0.917099 0.201117 1.40264 0 1.90892 0H7.63566C8.14194 0 8.62748 0.201117 8.98547 0.559108C9.34346 0.917099 9.54458 1.40264 9.54458 1.90892V2.54522C9.54458 2.89664 9.25969 3.18153 8.90827 3.18153C8.55685 3.18153 8.27197 2.89664 8.27197 2.54522V1.90892C8.27197 1.74016 8.20493 1.57831 8.0856 1.45898C7.96627 1.33965 7.80442 1.27261 7.63566 1.27261H1.90892Z",
    fill: fill
  }))));
};

exports["default"] = _default;